var initialize = function (broadcast_group_div) {};

export default initialize;
